import axios from 'axios'
import { clearToken } from 'utils/storeToken'

const domain = process.env.REACT_APP_API_URL

const apiClient = axios.create({
  baseURL: domain,
})

apiClient.interceptors.response.use(undefined, error => {
  const { response } = error
  if (response?.status === 401) {
    clearToken()
    window.location.href = '/account/login'
  } else if (response?.status === 421) {
    const { store_uri } = response?.data ?? {}
    clearToken()
    window.location.href = store_uri
  }
  error.data = response?.data ?? {}
  return Promise.reject(error)
})

export default apiClient
